import { ILoginCredentials } from "../pages/ProfileMenu";
import { IUser, IUserAddress } from "../types/IUser";
import { HttpClient } from "./http/httpclient.service";
import { ApiRoutes } from "./http/routes";

const UserService = {
  async triggerOTPForValidation(loginBody: ILoginCredentials): Promise<any> {
    try {
      //const userdetails = await HttpClient.get({route:ApiRoutes.GetUsers});
      const response = await HttpClient.post({
        route: ApiRoutes.TriggerOTPForValidation,
        body: (loginBody)
      });
      return response.data; // Expected to return user details
    }
    catch (error) {

    }
    finally {

    }
  },
  //TriggerOTPForValidation
  // Verify OTP and create user if needed
  async verifyOtpAndFetchUser(loginBody: ILoginCredentials): Promise<any> {
    try {
      //const userdetails = await HttpClient.get({route:ApiRoutes.GetUsers});
      const response = await HttpClient.post({
        route: ApiRoutes.ValidateOtpAndFetchUser,
        body: (loginBody)
      });
      return response.data; // Expected to return user details
    }
    catch (error) {

    }
    finally {

    }
  },

  async getUser(tenantId: string, id: string): Promise<IUser> {
    try {
      const response = await HttpClient.get<IUser>({
        route: ApiRoutes.GetUser,
        uriParams: ({ tenantId: tenantId, id: id })
      });
      return response.data as IUser; // Expected to return user details
    }
    catch (error) {
      return {}  as IUser;
    }
    finally {

    }
  },

  async updateUser(user: IUser): Promise<any> {
    try {
      const response = await HttpClient.patch({
        route: ApiRoutes.UpdateUser,
        body: user,
      });
      return response.data; // Expected to return user details
    }
    catch (error) {

    }
    finally {

    }
  },

  async addAddress(address: IUserAddress): Promise<any> {
    try {
      const response = await HttpClient.put({
        route: ApiRoutes.AddAddress,
        body: address,
      });
      return response.data; // Expected to return user details
    }
    catch (error) {

    }
    finally {

    }
  },

  async updateAddress(address: IUserAddress): Promise<any> {
    try {
      const response = await HttpClient.put({
        route: ApiRoutes.UpdateAddress,
        body: address,
      })
      return response;
    } catch (error) {
      console.error("Error updating address:", error);
    }
  },

  async deleteAddress(addressId: string, tenantId: string, LoginId: string | null): Promise<any> {
    const response = await HttpClient.delete({
      route: ApiRoutes.DeleteAddress,
      uriParams: ({ addressId: addressId, tenantId: tenantId, LoginId: LoginId }),
    })
    return response.data;
  },

  async updateDefaultAddress(addressId: string, tenantId: string, loginId: string | null): Promise<any> {
    try {
      const response = await HttpClient.post({
        route: ApiRoutes.UpdateDefaultAddress,
        uriParams: ({ addressId: addressId, tenantId: tenantId, loginId: loginId }),
      })
      return response.data;
    }
    catch (error) {
      console.log(error);
    }
    finally {

    }
  }

};

export default UserService;